import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const SandhyaBordewekar = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Sandhya Bordewekar"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Sandhya-Bordewekar-bio-scaled.jpg"
                bio="Sandhya Bordewekar studied English, Continental and American Literature, and Art History and Criticism at the M.S University of Baroda. She has been writing extensively on Contemporary Indian Art, Architecture, Cultural Issues, and Social Development subjects over the last 35 years in journals in India and abroad. While her articles, artist interviews, book and exhibition reviews have appeared in mainstream newspapers, news portals as well as niche magazines and journals, she has been the contributing correspondent for Art India, India’s premier magazine on Contemporary Art, for the last 20 years. She has also written for Katalog (Denmark), Nigaah (Pakistan), DepArt (Bangladesh). She has authored art catalogs, invited on juries for art shows and collaborated with art galleries in India and UK to curate exhibitions to showcase young artists from India. She has also undertaken research projects related to cultural documentation. In June 2018 she was selected by Arts Forum SF for a month-long Residency at the Lucas Artists Program at the Montalvo Arts Center, Saratoga, USA."
            />
        </>
    );
};

export default SandhyaBordewekar;